import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/firebase/auth.service';
import { CommonService } from '../../../../../services/common.service';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent implements OnInit {

    public firstName: string;
    public profileImg: string;
    public lastName: string;
    //public IWantToMenu: [];
    constructor(private _router: Router, public common: CommonService, public authService: AuthService) {
      var authorizationUserData = JSON.parse(localStorage.getItem('authorizationUserData'));
      if (authorizationUserData != null) {
          this.firstName = authorizationUserData.firstName;
          this.lastName = authorizationUserData.lastName;
          this.profileImg = authorizationUserData.contactLogo;
      } else {
          console.log("NO ");
      }

  }


  logoutFunc() {
    this.authService.SignOut();
  }

    ngOnInit() {
        console.log("IWANTTOMENU_header", this.common.IWantToMenu);
        //this.IWantToMenu = this.common.IWantToMenu;
    }
    open(path: any) {
        this._router.navigate([path])
    }
}
